// extracted by mini-css-extract-plugin
module.exports = {"heading":"Formulario_heading__3khjb","buscador":"Formulario_buscador__EPBBt","btn_block":"Formulario_btn_block__2-XJO"};